import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "logo w-full flex items-center",
  href: "/",
  target: "_blank"
};
const _hoisted_2 = ["src"];
import { computed, ref, watch } from "vue";
import { setMenuItems, useSidebarStore } from "@/store/sidebar";
import { httpGet } from "@/utils/http";
import { ElMessage } from "element-plus";
import { useRoute } from "vue-router";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'AdminSidebar',
  setup(__props) {
    const title = ref("");
    const logo = ref("");

    // 加载系统配置
    httpGet("/admin/config/get?key=system").then(res => {
      title.value = res.data.admin_title;
      logo.value = res.data.logo;
    }).catch(e => {
      ElMessage.error("加载系统配置失败: " + e.message);
    });
    const store = useSharedStore();
    const theme = ref(store.theme);
    watch(() => store.theme, val => {
      theme.value = val;
    });
    const items = [{
      icon: "home",
      index: "/admin/dashboard",
      title: "仪表盘"
    }, {
      icon: "user-fill",
      index: "/admin/user",
      title: "用户管理"
    }, {
      icon: "menu",
      index: "1",
      title: "应用管理",
      subs: [{
        index: "/admin/app",
        title: "应用列表"
      }, {
        index: "/admin/app/type",
        title: "应用分类"
      }]
    }, {
      icon: "api-key",
      index: "/admin/apikey",
      title: "API-KEY"
    }, {
      icon: "model",
      index: "/admin/chat/model",
      title: "模型管理"
    }, {
      icon: "recharge",
      index: "/admin/product",
      title: "充值产品"
    }, {
      icon: "order",
      index: "/admin/order",
      title: "充值订单"
    }, {
      icon: "reward",
      index: "/admin/redeem",
      title: "兑换码"
    }, {
      icon: "control",
      index: "/admin/functions",
      title: "函数管理"
    }, {
      icon: "prompt",
      index: "/admin/chats",
      title: "对话管理"
    }, {
      icon: "image",
      index: "/admin/images",
      title: "绘图管理"
    }, {
      icon: "mp3",
      index: "/admin/medias",
      title: "音视频管理"
    }, {
      icon: "role",
      index: "/admin/manger",
      title: "管理员"
    }, {
      icon: "config",
      index: "/admin/system",
      title: "系统设置"
    }, {
      icon: "log",
      index: "/admin/powerLog",
      title: "用户算力日志"
    }, {
      icon: "log",
      index: "/admin/loginLog",
      title: "用户登录日志"
    }
    // {
    //   icon: 'menu',
    //   index: '1',
    //   title: '常用模板页面',
    //   subs: [
    //     {
    //       index: '/admin/demo/form',
    //       title: '表单页面',
    //     },
    //     {
    //       index: '/admin/demo/table',
    //       title: '常用表格',
    //     },
    //     {
    //       index: '/admin/demo/import',
    //       title: '导入Excel',
    //     },
    //     {
    //       index: '/admin/demo/editor',
    //       title: '富文本编辑器',
    //     },
    //   ],
    // },
    ];
    const route = useRoute();
    const onRoutes = computed(() => {
      return route.path;
    });
    const sidebar = useSidebarStore();
    setMenuItems(items);
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass('sidebar ' + theme.value)
      }, [_createElementVNode("a", _hoisted_1, [_createElementVNode("img", {
        src: logo.value
      }, null, 8, _hoisted_2), _withDirectives(_createElementVNode("span", {
        class: "text"
      }, _toDisplayString(title.value), 513), [[_vShow, !_unref(sidebar).collapse]])]), _createVNode(_component_el_menu, {
        class: "sidebar-el-menu",
        "default-active": onRoutes.value,
        collapse: _unref(sidebar).collapse,
        "background-color": "#324157",
        "text-color": "#bfcbd9",
        "active-text-color": "#20a0ff",
        "unique-opened": "",
        router: ""
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, item => {
          return _openBlock(), _createElementBlock(_Fragment, null, [item.subs ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            index: item.index,
            key: item.index
          }, {
            title: _withCtx(() => [_createElementVNode("i", {
              class: _normalizeClass('iconfont icon-' + item.icon)
            }, null, 2), _createElementVNode("span", null, _toDisplayString(item.title), 1)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subs, subItem => {
              return _openBlock(), _createElementBlock(_Fragment, null, [subItem.subs ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                index: subItem.index,
                key: subItem.index
              }, {
                title: _withCtx(() => [_createTextVNode(_toDisplayString(subItem.title), 1)]),
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subItem.subs, (threeItem, i) => {
                  return _openBlock(), _createBlock(_component_el_menu_item, {
                    key: i,
                    index: threeItem.index
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(threeItem.title), 1)]),
                    _: 2
                  }, 1032, ["index"]);
                }), 128))]),
                _: 2
              }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
                index: subItem.index,
                key: subItem.index
              }, {
                default: _withCtx(() => [subItem.icon ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass('iconfont icon-' + subItem.icon)
                }, null, 2)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(subItem.title), 1)]),
                _: 2
              }, 1032, ["index"]))], 64);
            }), 256))]),
            _: 2
          }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
            index: item.index,
            key: item.index
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            default: _withCtx(() => [_createElementVNode("i", {
              class: _normalizeClass('iconfont icon-' + item.icon)
            }, null, 2)]),
            _: 2
          }, 1032, ["index"]))], 64);
        }), 64))]),
        _: 1
      }, 8, ["default-active", "collapse"])], 2);
    };
  }
};